import React, { Component } from 'react'
import { connect } from 'react-redux'
import { countryRegionData } from '../Constants/countryRegionData'
import { MenuItem } from '@material-ui/core'

import { MerchantOnboardingActions } from '../Actions/merchantOnboardingActions'
import CssTextField from '../Components/UI/CssTextField'

class BillingAddressForm extends Component {
  state = {
    address: false,
    province: false,
    city: false,
    zip: false,
  }

  componentDidMount = () => {
    // Return validateForm() as a callback so it can be
    // accessed by its parent element
    this.props.callValidateForm(this.validateForm.bind(this))
  }

  validateForm = () => {
    const form = this.props.onboarding.billingAddress

    this.setState({
      address: form.streetAddress1 === '',
      province: form.state === '',
      city: form.city === '',
      zip: form.zipCode === '',
    })

    return (
      form.streetAddress1 === '' || form.state === '' || form.city === '' || form.zipCode === ''
    )
  }

  handleChange = name => event => {
    this.props[name](event.target.value)
  }

  getRegions = country => {
    if (!country) {
      return []
    }
    return country[2].split('|').map(regionPair => {
      let regionName = regionPair.split('~')
      return regionName
    })
  }

  render() {
    const { onboarding, styles } = this.props

    return (
      <div>
        <div style={styles.merchantInputFieldRow}>
          <CssTextField
            label="Address 1"
            margin="normal"
            error={this.state.address}
            variant="outlined"
            style={styles.textFieldFullWidth}
            value={onboarding.billingAddress.streetAddress1}
            onChange={this.handleChange('addBillingAddress1')}
          />
        </div>

        <div style={styles.merchantInputFieldRow}>
          <CssTextField
            label="Address 2"
            margin="normal"
            variant="outlined"
            style={styles.textFieldFullWidth}
            value={onboarding.billingAddress.streetAddress2}
            onChange={this.handleChange('addBillingAddress2')}
          />
        </div>

        <div style={styles.merchantInputFieldRow}>
          <CssTextField
            select
            label="Province or State"
            margin="normal"
            error={this.state.province}
            variant="outlined"
            value={onboarding.billingAddress.state}
            style={styles.textFieldHalfWidth}
            onChange={this.handleChange('addBillingState')}>
            {this.getRegions(onboarding.billingAddress.country).map(option => (
              <MenuItem key={option[1]} value={option[1]}>
                {option[0]}
              </MenuItem>
            ))}
          </CssTextField>

          <div style={{ padding: '0 8px' }} />

          <CssTextField
            select
            label="Country"
            margin="normal"
            variant="outlined"
            value={onboarding.billingAddress.country}
            style={styles.textFieldHalfWidth}
            onChange={this.handleChange('addBillingCountry')}>
            {countryRegionData.map(option => (
              <MenuItem key={option[0]} value={option}>
                {option[0]}
              </MenuItem>
            ))}
          </CssTextField>
        </div>

        <div style={styles.merchantInputFieldRow}>
          <CssTextField
            label="City"
            margin="normal"
            error={this.state.city}
            variant="outlined"
            style={styles.textFieldHalfWidth}
            value={onboarding.billingAddress.city}
            onChange={this.handleChange('addBillingCity')}
          />

          <div style={{ padding: '0 8px' }} />

          <CssTextField
            label="Postal/Zip Code"
            margin="normal"
            error={this.state.zip}
            variant="outlined"
            style={styles.textFieldHalfWidth}
            value={onboarding.billingAddress.zipCode}
            onChange={this.handleChange('addBillingZipCode')}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    onboarding: state.onboarding,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBillingAddress1: street => dispatch(MerchantOnboardingActions.addBillingAddress1(street)),
    addBillingAddress2: unit => dispatch(MerchantOnboardingActions.addBillingAddress2(unit)),
    addBillingState: state => dispatch(MerchantOnboardingActions.addBillingState(state)),
    addBillingCountry: country => dispatch(MerchantOnboardingActions.addBillingCountry(country)),
    addBillingCity: city => dispatch(MerchantOnboardingActions.addBillingCity(city)),
    addBillingZipCode: zip => dispatch(MerchantOnboardingActions.addBillingZipCode(zip)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillingAddressForm)
